import axios from 'axios';
import {
  mobileVendor,
  mobileModel,
  osName,
  browserName,
  osVersion,
  fullBrowserVersion } from 'react-device-detect';
import {
  POST_CONTACT_US_FORM_REQUEST,
  POST_CONTACT_US_FORM_SUCCESS,
  POST_CONTACT_US_FORM_FAILURE,
  GET_CONTACT_US_CATEGORIES_REQUEST,
  GET_CONTACT_US_CATEGORIES_SUCCESS,
  GET_CONTACT_US_CATEGORIES_FAILURE,
  GET_AUTH_CONTACT_US_CATEGORIES_REQUEST,
  GET_AUTH_CONTACT_US_CATEGORIES_SUCCESS,
  GET_AUTH_CONTACT_US_CATEGORIES_FAILURE,
  GET_CAPTCHA_HASH_REQUEST,
  GET_CAPTCHA_HASH_SUCCESS,
  GET_CAPTCHA_HASH_FAILURE,
  CAPTCHA_VERIFY_REQUEST,
  CAPTCHA_VERIFY_SUCCESS,
  CAPTCHA_VERIFY_FAILURE
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import { getChannel } from 'Utils/channel';
import ProjectConfig from 'ProjectConfig';
import qs from 'query-string';

const API_GATEWAY = ProjectConfig.API_GATEWAY;
const PACKAGE_VERSION = ProjectConfig.version;

export const postContactUsV2Form = formData => async (dispatch, getState) => {
  const { isAuthenticated } = getState().auth;

  const formDataWithClientDetails = {
    ...formData,
    clientDetails: {
      appVersion: PACKAGE_VERSION,
      os: `${osName} ${osVersion}`,
      device: `${mobileVendor} ${mobileModel}`,
      name: `${browserName} ${fullBrowserVersion}`
    }
  };
  try {
    dispatch({
      type: POST_CONTACT_US_FORM_REQUEST
    });

    const url = isAuthenticated ? `${API_GATEWAY}/bip-ticket-v2` : `${API_GATEWAY}/bip-ticket-v2/anonymous`;

    const res = await axios({
      url,
      method: 'POST',
      data: formDataWithClientDetails,
      headers: {
        channel: getChannel()
      }
    });

    dispatch({
      type: POST_CONTACT_US_FORM_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: POST_CONTACT_US_FORM_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
    return e.response.data;
  }
};

export const getCategoriesV2 = isRating => async dispatch => {
  try {
    dispatch({
      type: GET_CONTACT_US_CATEGORIES_REQUEST
    });

    const res = await axios({
      method: 'GET',
      url: `${API_GATEWAY}/bip-ticket-v2/categories?isRating=${isRating}`
    });

    dispatch({
      type: GET_CONTACT_US_CATEGORIES_SUCCESS,
      payload: res.data
    });

    return res?.data;
  } catch (e) {
    dispatch({
      type: GET_CONTACT_US_CATEGORIES_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getAuthCategoriesV2 = () => async dispatch => {
  try {
    dispatch({
      type: GET_AUTH_CONTACT_US_CATEGORIES_REQUEST
    });

    const res = await axios({
      method: 'GET',
      url: `${API_GATEWAY}/bip-ticket-v2/auth/categories`
    });

    dispatch({
      type: GET_AUTH_CONTACT_US_CATEGORIES_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_AUTH_CONTACT_US_CATEGORIES_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getLatestContactUsAgreement = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios({
        url: `${API_GATEWAY}/cms/userAgreement/latestContactUsAgreement`,
        method: 'get'
      });

      resolve(res);
    } catch (e) {
      reject(e);
    }
  });
};


export const isEmailVerifiedInSixMonths = email => async dispatch => {
  try {
    const url = qs.stringifyUrl({
      url: `${API_GATEWAY}/users/status-change/is-email-verified`,
      query: { email },
    });

    const res = await axios.get(url);
    return res.data;

  } catch (err) {
    //console.log('err: ', err);
  }
};


export const emailVerify = () => async dispatch => {
  try {
    await axios.post(`${API_GATEWAY}/users/send/email-code`);
    return true;

  } catch (err) {
    throw {
      code: err?.response?.data?.code,
      message: err?.response?.data?.message,
    };
  }
};

export const getLatestPersonalizationAgreement = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios({
        url: `${API_GATEWAY}/cms/userAgreement/v2/kisisellestirme-aydinlatma-metni/latest`,
        method: 'get'
      });

      resolve(res);
    } catch (e) {
      reject(e);
    }
  });
};

export const getCaptchaHash = () => async dispatch => {
  try {
    dispatch({
      type: GET_CAPTCHA_HASH_REQUEST
    });

    const res = await axios({
      method: 'GET',
      url: `${API_GATEWAY}/captcha/get`
    });

    dispatch({
      type: GET_CAPTCHA_HASH_SUCCESS,
      payload: res.data
    });
    return res?.data;
    
  } catch (e) {
    dispatch({
      type: GET_CAPTCHA_HASH_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const captchaVerify = (captchaValue, captchaHash, email) => async dispatch => {
  try {
    dispatch({
      type: CAPTCHA_VERIFY_REQUEST
    });
    const res = await axios({
      method: 'POST',
      url: `${API_GATEWAY}/users/send/email-code/with-captcha`,
      data: {
        captcha: {
          captcha: captchaValue,
          captchaHash: captchaHash
        },
        email: email
      }
    });

    dispatch({
      type: CAPTCHA_VERIFY_SUCCESS,
      payload: res.data
    });
    return res;
    
  } catch (e) {
    dispatch({
      type: CAPTCHA_VERIFY_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
    return e.response;
  }
};
